import * as amplitude from '@amplitude/analytics-browser';
import { AmplitudeEventProperties } from './events';
import { debounce } from 'lodash';

const getAmplitudeApiKey = () => {
  // const env = process.env.NEXT_PUBLIC_ENV || 'dev';
  // if (env === 'production') {
  //   return process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;
  // } else if (env === 'staging') {
  //   return process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;
  // }
  // return null; // No key for development

  return process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;
};

export const initAmplitude = (userId?: string) => {
  if (typeof window !== 'undefined') {
    const apiKey = getAmplitudeApiKey();
    const env = process.env.NEXT_PUBLIC_ENV || 'dev';

    // if (!apiKey && env !== 'dev') {
    //   // console.error(`Amplitude API key is missing for ${env} environment.`);
    //   return;
    // }

    // if (env === 'dev') {
    //   // console.log('[Amplitude] Initialization skipped in development');
    //   return;
    // }

    try {
      amplitude.init(apiKey!, {
        defaultTracking: {
          pageViews: false, // Explicit page view tracking
          sessions: true,
          formInteractions: false,
          fileDownloads: false,
        },
        logLevel: amplitude.Types.LogLevel.Warn,
      });

      if (userId) {
        amplitude.setUserId(userId);
      }

      // console.log(`[Amplitude] Initialized for  environment`);
    } catch (error) {
      // console.error(`[Amplitude] Failed to initialize in `, error);
    }
  }
};

export const trackEvent = debounce(
  <T extends keyof AmplitudeEventProperties>(
    eventName: T,
    eventProperties?: AmplitudeEventProperties[T],
  ) => {
    if (typeof window === 'undefined') return;

    const env = process.env.NEXT_PUBLIC_ENV || 'dev';
    const eventData = { ...eventProperties, environment: env }; // Add environment to all events

    // if (env === 'dev') {
    //   // console.log(`[Amplitude Dev] Event: ${eventName}`, eventData);
    //   return;
    // }

    try {
      amplitude.track(eventName, eventData);
      console.log(`[Amplitude ${env}] Tracked event: ${eventName}`, eventData);
    } catch (error) {
      console.error(`[Amplitude ${env}] Failed to track event ${eventName}:`, error);
    }
  },
  300,
);

export const resetAmplitude = () => {
  if (typeof window === 'undefined') return;

  // const env = process.env.NEXT_PUBLIC_ENV || 'dev';
  // if (env === 'dev') {
  //   // console.log('[Amplitude Dev] Reset user');
  //   return;
  // }

  try {
    amplitude.reset();
    // console.log(`[Amplitude ${env}] User reset`);
  } catch (error) {
    // console.error(`[Amplitude ${env}] Failed to reset Amplitude:`, error);
  }
};
